import { StateCreator } from "zustand";

export interface TranslationSlice {
  translation: string;
  translate: string;
  setTranslation: (lng: string) => void;
  setTranslate: (value: string) => void;
}

export const createTranslationSlice: StateCreator<TranslationSlice> = set => ({
  translation: "ru",
  translate: "",
  setTranslation: (lng: string) => set(() => ({ translation: lng })),
  setTranslate: (translate: string) => set(() => ({ translate })),
});
